import {EmbeddedComponent, isEmbeddedComponent} from "./EmbeddedComponent";

export interface CommonOrgTabComponent extends EmbeddedComponent {
  hash?: string;
  contained?: boolean;
}

export function isCommonOrgTabComponent(
  arg: any
): arg is CommonOrgTabComponent {
  return (
    isEmbeddedComponent(arg) &&
    (!("hash" in arg) || typeof arg.hash === "string") &&
    (!("contained" in arg) || typeof arg.contained === "boolean")
  );
}

export const tabLabelKeyFromHash = (hash: string) =>
  `tab-components.${hash}.tab-label`;

export const tabLabelKeyFor = (component: CommonOrgTabComponent) =>
  `tab-components.${component.element}.tab-label`;
